import { render, staticRenderFns } from "./GSchoolClassChangeWorkSpace.vue?vue&type=template&id=054258d9&scoped=true&"
import script from "./GSchoolClassChangeWorkSpace.vue?vue&type=script&lang=ts&"
export * from "./GSchoolClassChangeWorkSpace.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "054258d9",
  null
  
)

export default component.exports